<ng-container *ngIf="isLoading; else pageContent">
  <div class="app-spinner">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
</ng-container>

<ng-template #pageContent>
  <ng-container *ngIf="collegeProfile; else showMessage">
    <div class="college-profile-wrapper">
      <button class="back-btn" (click)="goBack()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M19 12H5M12 19l-7-7 7-7" />
        </svg>
        Back
      </button>

      <div class="hero-banner-card">
        <div class="banner-gradient"></div>
        <div class="banner-bottom">
          <div class="college-logo-box" [class.has-img]="!!collegeProfileForm.get('logo_url')?.value">
            <ng-container *ngIf="!collegeProfileForm.get('logo_url')?.value">
              {{ collegeProfile.college_name.charAt(0).toUpperCase() || "C" }}
            </ng-container>
            <img *ngIf="collegeProfileForm.get('logo_url')?.value"
                 [src]="getLogoUrl(collegeProfileForm.get('logo_url')?.value)" class="logo-img" alt="College Logo" />
          </div>
          <h1 class="college-name-heading">{{ collegeProfile.college_name }}</h1>
        </div>
      </div>

      <div class="profile-card">
        <div class="card-header-row">
          <div class="header-title-group">
            <div class="title-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
                <path d="M6 12v5c3 3 9 3 12 0v-5" />
              </svg>
            </div>
            <div>
              <h2 class="card-title">College Profile Details</h2>
              <p class="card-subtitle">Public details and contact information about your institution</p>
            </div>
          </div>

          <div class="header-actions">
            <button class="btn-edit" *ngIf="!isEditMode" (click)="toggleEditMode()">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 20h9" />
                <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
              </svg>
              Edit
            </button>

            <ng-container *ngIf="isEditMode">
              <button class="btn-cancel" (click)="cancelEdit()">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
                Cancel
              </button>
              <button class="btn-save" [disabled]="collegeProfileForm.invalid" (click)="saveProfile()">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
                  <polyline points="17 21 17 13 7 13 7 21" />
                  <polyline points="7 3 7 8 15 8" />
                </svg>
                Save
              </button>
            </ng-container>
          </div>
        </div>

        <!-- VIEW MODE -->
        <div class="card-body view-mode-body" *ngIf="!isEditMode">
          <h3 class="section-divider-title">College Information</h3>

          <div class="logo-display-group">
            <label class="field-lbl">College Logo</label>
            <div class="logo-preview-box" [class.has-img]="!!collegeProfileForm.get('logo_url')?.value">
              <ng-container *ngIf="!collegeProfileForm.get('logo_url')?.value">
                {{ collegeProfile.college_name.charAt(0).toUpperCase() || "C" }}
              </ng-container>
              <img *ngIf="collegeProfileForm.get('logo_url')?.value"
                   [src]="getLogoUrl(collegeProfileForm.get('logo_url')?.value)" class="logo-img" alt="College Logo" />
            </div>
          </div>

          <div class="form-grid">
            <div class="field-item">
              <label class="field-lbl">College Name</label>
              <p class="field-val">{{ collegeProfile.college_name || "—" }}</p>
            </div>
            <div class="field-item">
              <label class="field-lbl">University Name</label>
              <p class="field-val">{{ collegeProfile.university_name || "—" }}</p>
            </div>
            <div class="field-item">
              <label class="field-lbl">Ranking</label>
              <p class="field-val">{{ collegeProfile.ranking || "—" }}</p>
            </div>
            <div class="field-item">
              <label class="field-lbl">
                <svg class="lbl-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                     fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="2" y1="12" x2="22" y2="12" />
                  <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                </svg>
                Website
              </label>
              <p class="field-val">{{ collegeProfile.college_url || "—" }}</p>
            </div>
            <div class="field-item">
              <label class="field-lbl">
                <svg class="lbl-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                     fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
                Location
              </label>
              <p class="field-val">
                {{ collegeProfile.city || "—" }}<span *ngIf="collegeProfile.city && collegeProfile.state">, </span>{{ collegeProfile.state }}<span *ngIf="collegeProfile.country">, {{ collegeProfile.country }}</span>
              </p>
            </div>
          </div>

          <div class="field-item full-width">
            <label class="field-lbl">Streams</label>
            <div class="chip-list" *ngIf="collegeProfile.streams?.length; else noStreams">
              <span class="chip" *ngFor="let s of collegeProfile.streams">{{ s }}</span>
            </div>
            <ng-template #noStreams><p class="field-val">—</p></ng-template>
          </div>

          <div class="field-item full-width">
            <label class="field-lbl">Courses Offered</label>
            <div class="chip-list" *ngIf="collegeProfile.courses_offered?.length; else noCourses">
              <span class="chip" *ngFor="let c of collegeProfile.courses_offered">{{ c }}</span>
            </div>
            <ng-template #noCourses><p class="field-val">—</p></ng-template>
          </div>

          <div class="field-item full-width">
            <label class="field-lbl">Placement Industries</label>
            <div class="chip-list" *ngIf="collegeProfile.placement_industries?.length; else noIndustries">
              <span class="chip" *ngFor="let i of collegeProfile.placement_industries">{{ i }}</span>
            </div>
            <ng-template #noIndustries><p class="field-val">—</p></ng-template>
          </div>

          <h3 class="section-divider-title">Point of Contact</h3>
          <p class="section-desc">Registered college admin contact for BeExpert</p>
          <div class="form-grid">
            <div class="field-item">
              <label class="field-lbl">Contact Person</label>
              <p class="field-val">{{ collegeProfile.point_of_contact_name || "—" }}</p>
            </div>
            <div class="field-item">
              <label class="field-lbl">
                <svg class="lbl-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                     fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
                College Admin Email
              </label>
              <p class="field-val">{{ collegeProfile.point_of_contact_email || "—" }}</p>
            </div>
            <div class="field-item">
              <label class="field-lbl">
                <svg class="lbl-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                     fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
                Mobile
              </label>
              <p class="field-val">{{ collegeProfile.phone_number || "—" }}</p>
            </div>
          </div>
        </div>

        <!-- EDIT MODE -->
        <form [formGroup]="collegeProfileForm">
          <div class="card-body edit-mode-body" *ngIf="isEditMode">
            <h3 class="section-divider-title">College Information</h3>

            <div class="logo-edit-group">
              <label class="field-lbl">College Logo</label>
              <div class="logo-uploader-row">
                <div class="logo-preview-box sm" [class.has-img]="!!collegeProfileForm.get('logo_url')?.value">
                  <ng-container *ngIf="!collegeProfileForm.get('logo_url')?.value">
                    {{ collegeProfile.college_name.charAt(0).toUpperCase() || "C" }}
                  </ng-container>
                  <img *ngIf="collegeProfileForm.get('logo_url')?.value"
                       [src]="getLogoUrl(collegeProfileForm.get('logo_url')?.value)" class="logo-img" alt="College Logo" />
                </div>
                <div class="logo-actions">
                  <input type="file" #fileInput (change)="onLogoSelected($event)"
                         accept="image/png,image/jpeg,image/jpg,image/svg+xml,image/webp" style="display: none" />
                  <button type="button" class="btn-change-logo" (click)="triggerFileInput(fileInput)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                         stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                      <polyline points="17 8 12 3 7 8" />
                      <line x1="12" y1="3" x2="12" y2="15" />
                    </svg>
                    Change logo
                  </button>
                  <button type="button" class="btn-remove-logo" (click)="removeLogo()"
                          *ngIf="collegeProfileForm.get('logo_url')?.value">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                         stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <line x1="18" y1="6" x2="6" y2="18" />
                      <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                    Remove
                  </button>
                  <span class="logo-hint">PNG, JPG, SVG or WebP up to 2MB</span>
                </div>
              </div>
            </div>

            <div class="form-grid">
              <div class="field-item">
                <label class="field-lbl">College Name</label>
                <input type="text" class="standard-input" formControlName="college_name" readonly />
              </div>
              <div class="field-item">
                <label class="field-lbl">University Name</label>
                <input type="text" class="standard-input" formControlName="university_name" placeholder="Affiliated university" />
              </div>
              <div class="field-item">
                <label class="field-lbl">Ranking</label>
                <input type="text" class="standard-input" formControlName="ranking" placeholder="e.g. NIRF 150-200" />
              </div>
              <div class="field-item">
                <label class="field-lbl">
                  <svg class="lbl-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                       fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <line x1="2" y1="12" x2="22" y2="12" />
                    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                  </svg>
                  Website
                </label>
                <input type="text" class="standard-input" formControlName="college_url" placeholder="Enter website URL" />
                <small class="text-danger smaller-text"
                       *ngIf="collegeProfileForm.get('college_url')?.touched && collegeProfileForm.get('college_url')?.hasError('pattern')">
                  Please enter a valid website URL, e.g. https://www.example.com
                </small>
              </div>
              <div class="field-item">
                <label class="field-lbl">City</label>
                <input type="text" class="standard-input" formControlName="city" placeholder="City" />
              </div>
              <div class="field-item">
                <label class="field-lbl">State</label>
                <input type="text" class="standard-input" formControlName="state" placeholder="State" />
              </div>
              <div class="field-item">
                <label class="field-lbl">Country</label>
                <input type="text" class="standard-input" formControlName="country" readonly />
              </div>
            </div>

            <!-- Streams multi-select -->
            <div class="field-item full-width" style="position: relative;">
              <label class="field-lbl">Streams<span class="required-star">*</span></label>
              <input type="text" class="standard-input" placeholder="Search streams e.g. BCA, B.Com, BE..."
                     (input)="onStreamInput($event)" (blur)="showStreamsDropdown = false"
                     #streamInput (keydown.enter)="$event.preventDefault(); addStream(streamInput.value); streamInput.value=''" />
              <div class="chip-dropdown" *ngIf="showStreamsDropdown">
                <div class="chip-option" *ngFor="let s of filteredStreams" (mousedown)="addStream(s); streamInput.value=''">{{ s }}</div>
              </div>
              <div class="chip-list">
                <span class="chip removable" *ngFor="let s of streams; let i = index">
                  {{ s }} <i class="bi bi-x" (click)="removeStream(i)"></i>
                </span>
              </div>
            </div>

            <!-- Courses offered multi-select -->
            <div class="field-item full-width" style="position: relative;">
              <label class="field-lbl">Courses Offered</label>
              <input type="text" class="standard-input" placeholder="Search branches e.g. Computer Science, Mechanical..."
                     (input)="onBranchInput($event)" (blur)="showBranchesDropdown = false"
                     #branchInput (keydown.enter)="$event.preventDefault(); addBranch(branchInput.value); branchInput.value=''" />
              <div class="chip-dropdown" *ngIf="showBranchesDropdown">
                <div class="chip-option" *ngFor="let c of filteredBranches" (mousedown)="addBranch(c); branchInput.value=''">{{ c }}</div>
              </div>
              <div class="chip-list">
                <span class="chip removable" *ngFor="let c of coursesOffered; let i = index">
                  {{ c }} <i class="bi bi-x" (click)="removeBranch(i)"></i>
                </span>
              </div>
            </div>

            <!-- Placement industries multi-select -->
            <div class="field-item full-width" style="position: relative;">
              <label class="field-lbl">Placement Industries<span class="required-star">*</span></label>
              <input type="text" class="standard-input" placeholder="Search industries e.g. IT, Finance..."
                     (input)="onIndustryInput($event)" (blur)="showIndustriesDropdown = false"
                     #industryInput (keydown.enter)="$event.preventDefault(); addIndustry(industryInput.value); industryInput.value=''" />
              <div class="chip-dropdown" *ngIf="showIndustriesDropdown">
                <div class="chip-option" *ngFor="let ind of filteredIndustries" (mousedown)="addIndustry(ind); industryInput.value=''">{{ ind }}</div>
              </div>
              <div class="chip-list">
                <span class="chip removable" *ngFor="let ind of placementIndustries; let i = index">
                  {{ ind }} <i class="bi bi-x" (click)="removeIndustry(i)"></i>
                </span>
              </div>
            </div>

            <h3 class="section-divider-title">Point of Contact</h3>
            <p class="section-desc">Registered college admin contact for BeExpert</p>
            <div class="form-grid">
              <div class="field-item">
                <label class="field-lbl">Contact Person<span class="required-star">*</span></label>
                <input type="text" class="standard-input" formControlName="point_of_contact_name" placeholder="Enter contact name" />
              </div>
              <div class="field-item">
                <label class="field-lbl">
                  <svg class="lbl-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                       fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <polyline points="22,6 12,13 2,6" />
                  </svg>
                  College Admin Email
                </label>
                <input type="email" class="standard-input" formControlName="point_of_contact_email" readonly />
              </div>
              <div class="field-item">
                <label class="field-lbl">
                  <svg class="lbl-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                       fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                  </svg>
                  Mobile
                </label>
                <input type="tel" class="standard-input" formControlName="phone_number" readonly />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </ng-container>
  <ng-template #showMessage>
    <p class="text-center">No profile data available</p>
  </ng-template>
</ng-template>
